import { render, staticRenderFns } from "./TaskWrapper.vue?vue&type=template&id=30d9aa8c&"
import script from "./TaskWrapper.vue?vue&type=script&lang=js&"
export * from "./TaskWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports